import {AxiosHttpAdapterNoToken} from 'infra/http/axios-http-adapter-no-token';

export const makeAxiosHttpClientNoToken = (): AxiosHttpAdapterNoToken =>
	new AxiosHttpAdapterNoToken();
